import React from 'react'
import styled from '@emotion/styled'
import Popover from '../shared/Popover'
import NavHeader from './NavHeader'
import NavHeaderMenu from './NavHeaderMenu'
import MenuItem from './MenuItem'
import Submenu from './Submenu'
import Spinner from 'components/shared/Spinner'

import { useSelector } from 'react-redux'
import * as Selectors from 'state/selectors'

const NavbarContainer = styled.nav`
  position: relative;
  min-width: 214px;
  height: 100%;
  background-color: #28282E;
  color: #90A1B0;
  padding: 16px;
  width: 13.375%;
`
const ScrollableWrapper = styled.div`
  width: 100%;
  max-height: 350px;
  overflow-y: auto;
`

const ASSIGNEE_FILTER_TYPE = 'assignee',
      ARCHIVED_FILTER_TYPE = 'archived',
      ALL_FILTER_TYPE = 'all',
      INBOXES_FILTER_TYPE = 'inboxes'

/* Potential piece of state: activeNav */
const Navbar = () => {
  const inboxesState = useSelector(Selectors.getInboxesState)
  const counters = useSelector(Selectors.getCounters)

  const {
    isRequesting,
    collection
  } = inboxesState

  return (
    <NavbarContainer>
      {isRequesting && <Spinner />}

      <Popover
        trigger={popoverProps =>
          <NavHeader
            {...popoverProps}
          />
        }
        type='block'
        position='bottom'
        showChevron
      >
        <NavHeaderMenu />
      </Popover>

      <MenuItem
        highlighted
        route={ASSIGNEE_FILTER_TYPE}
        filterType='filter'
        title={'Assigned to me'}
        counter={counters?.assigned}
      />

      <MenuItem
        highlighted
        route={INBOXES_FILTER_TYPE}
        filterType='filter'
        title='Inboxes'
        counter={counters?.inboxesSum}
      />

      <ScrollableWrapper>
        {
          collection.map((inbox, i) => (
            <MenuItem
              key={i}
              title={inbox.title}
              route={`${inbox.inboxId}`}
              filterType='inbox'
              counter={counters?.inboxes[inbox.inboxId]}
            />
          ))
        }
      </ScrollableWrapper>

      <MenuItem
        title = 'All Messages'
        route = {ALL_FILTER_TYPE}
        filterType ='filter'
        counter = {counters?.all}
      />
      <MenuItem
        title = 'Archived'
        route = {ARCHIVED_FILTER_TYPE}
        filterType ='filter'
        counter = {counters?.archived}
      />

    </NavbarContainer>
  )
}

export default Navbar
